import { configureStore } from '@reduxjs/toolkit';

import { deliverySlice } from './delivery';
import { finishSlice } from './finish';
import { applicationSlice } from './application';
import { draftSlice } from './draft';
import { firstStepSlice } from './first-step';
import { smsSlice } from './sms';
import { basketSlice } from './basket';
import type { TState } from './models';

export const createStore = (preloadedState?: Partial<TState>) =>
    configureStore({
        reducer: {
            delivery: deliverySlice.reducer,
            finish: finishSlice.reducer,
            application: applicationSlice.reducer,
            draft: draftSlice.reducer,
            firstStep: firstStepSlice.reducer,
            sms: smsSlice.reducer,
            basket: basketSlice.reducer,
        },
        preloadedState,
    });
